export const scrollToId = (id: string): void => {
  const domElement = document.getElementById(id);
  if (domElement) {
    window.scrollTo({
      top: domElement.offsetTop,
      left: 0,
      behavior: "smooth",
    });
  }
};
